// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf } from "@altostra/type-validations";
import { number, string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGetGenerativeAiAgentsCanvasQaResult = objectOf({
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      tags: arrayOf(string),
      territory_ids: arrayOf(string),
      brand_guideline_id: anyOf(string, nullOrUndefined),
    })
  ),
  total: number,
});
